import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "state", "profession", "professionInput", "mainWorkArea", "mainWorkAreaInput"]

  connect() {
    this.initializeCountry()
  }

  initializeCountry() {
    if (this.countryTarget.value === "") {
      this.countryTarget.value = "AUS"
      this.countryChanged()
    }
  }

  countryChanged() {
    if (this.countryTarget.value === "AUS") {
      this.stateTarget.removeAttribute("disabled")
      this.stateTarget.setAttribute("required", "required")
      this.stateTarget.parentElement.classList.add("required")
    } else {
      this.stateTarget.setAttribute("disabled", "disabled")
      this.stateTarget.removeAttribute("required")
      this.stateTarget.classList.remove("ui-state-error")
      this.stateTarget.value = ""
      this.stateTarget.parentElement.classList.remove("required")
    }
  }

  professionChanged() {
    if (this.professionTarget.value === "Other (please specify)") {
      this.professionTarget.classList.add("d-none")
      this.professionTarget.setAttribute("disabled", "disabled")
      this.professionInputTarget.classList.remove("d-none")
      this.professionInputTarget.removeAttribute("disabled")
      this.professionInputTarget.focus()
    }
  }

  professionInputChanged() {
    if (this.professionInputTarget.value === "") {
      this.professionInputTarget.setAttribute("disabled", "disabled")
      this.professionInputTarget.classList.add("d-none")
      this.professionTarget.classList.remove("d-none")
      this.professionTarget.removeAttribute("disabled")
      this.professionTarget.focus()
    }
  }

  mainWorkAreaChanged() {
    if (this.mainWorkAreaTarget.value === "Other (please specify)") {
      this.mainWorkAreaTarget.setAttribute("disabled", "disabled")
      this.mainWorkAreaTarget.classList.add("d-none")
      this.mainWorkAreaInputTarget.classList.remove("d-none")
      this.mainWorkAreaInputTarget.removeAttribute("disabled")
      this.mainWorkAreaInputTarget.focus()
    }
  }

  mainWorkAreaInputChanged() {
    if (this.mainWorkAreaInputTarget.value === "") {
      this.mainWorkAreaInputTarget.setAttribute("disabled", "disabled")
      this.mainWorkAreaInputTarget.classList.add("d-none")
      this.mainWorkAreaTarget.classList.remove("d-none")
      this.mainWorkAreaTarget.removeAttribute("disabled")
      this.mainWorkAreaTarget.focus()
    }
  }
}